import { isStringEnumValue } from "@myvp/shared/src/functions/type-guards"
import { MyVeevaRegion } from "@myvp/shared/src/gql/graphql"

const isMyVeevaRegion = isStringEnumValue(MyVeevaRegion)

export const getRegion = (
  args: {
    hostname?: string
    fallbackRegion?: MyVeevaRegion
  } = {}
): MyVeevaRegion => {
  const hostname = args.hostname ?? window.location.hostname
  const region = getRegionFromHostname(hostname) ?? args.fallbackRegion

  return isMyVeevaRegion(region) ? region : MyVeevaRegion.Us
}

export const getRegionFromHostname = (
  hostname: string
): MyVeevaRegion | undefined => {
  const region = hostname.split("-")?.[1]?.split?.(".")?.[0]
  return isMyVeevaRegion(region) ? region : undefined
}
